import { useState } from 'react'
import linkCopy from "../../../favicon/linkCopy.svg"
import cancel from '../../../favicon/cancel.svg'
import cancelBlack2 from '../../../favicon/cancelBlack2.svg'
import like from "../../../favicon/reactionIcons/like.svg"
import haha from "../../../favicon/reactionIcons/haha.svg"
import love from "../../../favicon/reactionIcons/love.svg"
import sad from "../../../favicon/reactionIcons/sad.svg"
import share from "../../../favicon/reactionIcons/share.svg"
import wow from "../../../favicon/reactionIcons/wow.svg"
import angry from "../../../favicon/reactionIcons/angry.svg"
import send from "../../../favicon/reactionIcons/send.svg"
import love_black from "../../../favicon/reactionIcons/love_black.svg"
import send_black from "../../../favicon/reactionIcons/send_black.svg"
import currencyFormatter from '../../../Helpers/currencyFormatter'
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import CustomSlider from '../../comman/CustomSlider'
import { Notification, useToaster } from 'rsuite'
import { motion } from "framer-motion";
import { useEffect } from 'react'



const DetailModal = ({ showModal, setShowModal, item, handleRejectReasonChange, onHandleClick, trackPost }) => {
    const [showReasonForm, setShowReasonForm] = useState(false);
    const [selectedAction, setSelectedAction] = useState('Reject');
    const toaster = useToaster();
   
    console.log("showModali@:",showModal);
    
     useEffect(()=>{
        if (showModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
     },[showModal])


    const copyToClipBoard = async copyMe => {
        try {
            await navigator.clipboard.writeText(copyMe);
            toaster.push(<Notification type='success' header="Success"  >Link has been copied in clipbord </Notification>, {
                placement: 'topEnd'
            });
        } catch (err) {

        }
    };

    const showCardImdPost = (item) => {

        const vidArr = ["mp4", "mp4", "mov", "wmv", "avi", "avchd", "flv", "f4v", "swf", "mkv", "webm", "html5"];
        const imgArr = ["jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "webp", "avif", "gif", "apng"];


        let ext = item?.split('.').pop();

        let fext = ext.toLowerCase();

        const im = imgArr?.find((v) => v == fext);
        const vid = vidArr?.find((vi) => vi == fext);

        if (vid != undefined) {

            return (
                <video controls className='w-[220px] inline-block p-2 cursor-pointer hover:scale-105 ease-in-out duration-300'
                    src={item} alt="video not found" />
            )
        } if (im != undefined) {
            return (
                <img
                    className='w-[220px] sm:h-[120px]  inline-block p-2 cursor-pointer hover:scale-105 ease-in-out duration-300'
                    src={item}
                    alt='/'
                />
            )
        }
        else {
            return (
                <img className=" rounded-lg w-[220px] sm:h-[120px] " src={item} alt="img not found" />
            )
        }


    }


    const slideLeft = () => {
        var slider = document.getElementById('slider');
        slider.scrollLeft = slider.scrollLeft - 500;
    };

    const slideRight = () => {
        var slider = document.getElementById('slider');
        slider.scrollLeft = slider.scrollLeft + 500;
    };



    const handleTaskAction = (task) => {

        setSelectedAction(task)
        if (task === "Reject" || task === "Cancelled") {
            setShowReasonForm(true)
        } else {
            onHandleClick(task);
        }

    }


    const showStatusBasedOnCurrentStatusActions = (status) => {

        if (status === 'Pending') {
            return ['Accept', 'Reject', 'Cancelled'];
        }
        if (status === 'Accept') {
            return ['Reject', 'Cancelled'];
        }
        if (status === 'Reject') {
            return [];
        }
        if (status === 'Link posted') {
            return ['Approved', 'Reject'];
        }
        else
            return [];

    }


    const getColorBasedStatus = (status) => {
        if (status === 'Accept') {
            return 'accept';
        }
        if (status === 'Reject') {
            return 'reject';
        }
        if (status === 'Cancelled') {
            return 'cancel';
        }
        if (status === 'Pending') {
            return 'pending';
        }
        if (status === 'Link posted') {
            return 'link';
        }
        if (status === 'Approved') {
            return 'approve';
        }

    }
    const getActionStatusName = (status) => {
        if (status === 'Accept') {
            return 'Accept';
        }
        if (status === 'Reject') {
            return 'Reject';
        }
        if (status === 'Cancelled') {
            return 'Block';
        }
        if (status === 'Link posted') {
            return '';
        }
        if (status === 'Approved') {
            return 'Approve';
        } else
            return '';
    }
    const getTrackLinkColor = (social_platform_id) => {

        if (social_platform_id === 1)
            return 'linkBlue';
        if (social_platform_id === 2)
            return 'linkRed';
        if (social_platform_id === 3)
            return 'linkBlack';
    }
    const getStatusColor = (status) => {
        if (status === 'Reject') {
            return 'reject';
        }
        if (status === 'Cancelled')
            return 'cancel';
        if (status === 'Accept')
            return 'accept';
        if (status === 'Link posted')
            return 'link';
        if (status === 'Approved')
            return 'approve';
        if (status === 'Pending')
            return 'pending';

    }

    const getTextColor = (status) => {
        if (status === 'Reject') {
            return 'rejectText';
        }

        if (status === 'Cancelled')
            return 'cancelText';
        if (status === 'Accept')
            return 'acceptText';
        if (status === 'Link posted')
            return 'linkText';
        if (status === 'Approved')
            return 'approveText';
        if (status === 'PendingText')
            return 'pendingText';

    }


    const getStatusName = (status) => {
        if (status === 'Reject')
            return 'Rejected';
        if (status === 'Cancelled')
            return 'Cancelled';
        if (status === 'Accept')
            return 'Accepted';
        if (status === 'Link posted')
            return 'Link posted';
        if (status === 'Approved')
            return 'Approved';
        if (status === 'Pending')
            return 'Pending';
    }




    return (
        <>
            {showModal ? (
                <>
                    <div className=" justify-center  items-center flex flex-col fixed  inset-0 z-50 outline-none focus:outline-none">
                       <motion.div initial={{ opacity: 0, scale: 0.75, y: -200 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0, y: 200 }} transition={{ ease: "easeOut", duration: 0.3 }}
                       className="max-w-[95%] pr-2 rounded-lg bg-white relative mt-7 ">
                        <div className="absolute right-[6px] top-[-35px]" ><img onClick={() => setShowModal(false)} src={cancel} alt="cancel_img" className=" transition ease-in-out hover:scale-110  duration-300  cursor-pointer"></img></div>
                            <div  
                            className="sbar overflow-x-hidden max-h-[88vh] overflow-y-auto 
                              bg-white rounded-lg ">

                                <div key={item?.id} className="flex md:flex-row flex-col  "
                                    style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }}>

                                    <div className=" flex items-center justify-center  ">
                                        <CustomSlider data={item?.files} />
                                    </div>

                                    <div className="md:max-w-[75%] flex sm:flex-row flex-col justify-between w-full lg:m-4 p-2 pl-5 lg:pl-5 " >
                                        <div className=" ">
                                            <h5 className="text-[#178ACB] text-lg font-museobb  ">{item?.influencer_name}</h5>
                                            <div className>
                                                <p className="text-gray-600 font-museob ">has sent his request for campaign </p>
                                            </div>

                                            <div className="flex flex-wrap gap-1 py-1  " >
                                                {JSON.parse(item?.captions)?.map((caption, it) => (

                                                    <span key={it} className="bg-[#66BE9C]  text-white w-fit h-fit px-2 py-1 rounded-l-full rounded-r-full     text-xs text-center "> {caption?.value}</span>


                                                ))}
                                            </div>

                                        </div>



                                        <div className="flex sm:flex-col sm:mt-0 mt-4  flex-col justify-between  ">

                                            <p className="text-xl" >Status : <span className={` ${getTextColor(item?.status)} font-museobb `} >{getStatusName(item?.status)}</span> </p>



                                            <div className='flex flex-col ' >
                                                <h4 className='font-museobb' >Photo / Videos </h4>
                                                <div className=" flex gap-x-1 ">

                                                    {item?.files?.map((file, it) => (
                                                        <div key={`files-${file}`} className='hover:[#64aa7d] px-3 text-white text-xs font-museob tracking-wider  rounded-xl dark:bg-blue-200 dark:text-blue-800 dark:hover:bg-blue-300'>
                                                            <a href={`${file}`} target="_blank" rel="noreferrer" >{`File - ${(it + 1)}`}</a>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>





                                        </div>

                                    </div>


                                </div>
                                <div className='flex my-2 mx-5 flex-col px-2'>
                                    <h5 className='flex justify-center md:my-0 pb-2 my-2 '> Campaign task timeline</h5>
                                    <ol className="relative border-l border-gray-200 dark:border-gray-700">
                                        {item?.task_timeline?.map((history, i) => (
                                            <li key={`history-${i}`} className="mb-10 ml-6">
                                                <span className="flex absolute -left-3 justify-center items-center w-6 h-6 bg-blue-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900">
                                                    <svg aria-hidden="true" className="w-3 h-3 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path></svg>
                                                </span>
                                                <h3 className="flex items-center mb-1 text-lg font-semibold text-gray-900 dark:text-white">{history?.task} {i <= 0 && <span className="bg-blue-100 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 ml-3">Latest</span>}</h3>
                                                <time className="block mb-2 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">{history?.formatted_creation_date}</time>
                                                <p className="mb-4 text-base font-normal text-gray-500 dark:text-gray-400">{history?.description}</p>
                                                {history?.status === "Pending" && (
                                                    <div className='flex flex-col'>
                                                        <div className='relative flex items-center  w-full '>
                                                            <MdChevronLeft className='opacity-50 cursor-pointer hover:opacity-100' onClick={slideLeft} size={40} />
                                                            <div
                                                                id='slider'
                                                                className=' sbar w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth '
                                                            >
                                                                {history?.files?.map((file, it) => (
                                                                    <a rel="noreferrer" key={`files-${it}`} href={file} target="_blank" >{showCardImdPost(file)}</a>

                                                                ))}
                                                            </div>
                                                            <MdChevronRight className='opacity-50 cursor-pointer hover:opacity-100' onClick={slideRight} size={40} />
                                                        </div>



                                                        <p className={`inline-flex flex-wrap gap-y-2 items-center py-2 px-4 text-black font-medium `} >
                                                            Caption:
                                                            {history?.captions?.map(caption => (
                                                                <span className='bg-blue-100 text-blue-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 ml-3'> {caption}</span>
                                                            ))}
                                                        </p>
                                                    </div>
                                                )}
                                                <p className={`inline-flex items-center py-2 px-4 text-white font-medium ${getStatusColor(history?.status)} rounded-lg border `}>{getStatusName(history?.status)}</p>
                                            </li>

                                        ))}

                                    </ol>

                                </div>





                                {showReasonForm && (
                                    <div className='w-full border-b'>

                                        <div className="  font-museob  px-7     ">

                                            <div className="relative w-fit flex py-2 gap-x-4 sm:flex-row flex-col mt-3  ">

                                                <div>
                                                    <img onClick={() => setShowReasonForm(false)} src={cancelBlack2} alt="cancel_img" className=" w-7 -top-2 right-0 absolute transition ease-in-out delay-150  hover:scale-110  duration-300  cursor-pointer"></img>
                                                    <label htmlFor="reject_reason" className="block text-sm  text-gray-500">
                                                        Reason
                                                    </label>


                                                    <input
                                                        name="reject_reason"
                                                        id="reject_reason"
                                                        required
                                                        onChange={(e) => { handleRejectReasonChange(e) }}
                                                        autoComplete="address-level2"
                                                        className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2  px-3 shadow-sm  focus:outline-none sm:text-sm"
                                                    />
                                                </div>

                                                <div className="">
                                                    <label htmlFor="reject_reason" className="block text-sm  text-gray-500">
                                                        Please specify your rejection/cancellation
                                                    </label>


                                                    <textarea
                                                        name="reject_reason_description"
                                                        id="reject_reason_description"
                                                        required
                                                        onChange={(e) => handleRejectReasonChange(e)}
                                                        autoComplete="address-level2"
                                                        className="mt-1 block w-full rounded-md border border-gray-300 bg-white py-2  px-3  sm:min-w-[500px]  shadow-sm focus:outline-none sm:text-sm"
                                                    />
                                                </div>

                                            </div>

                                            <div >
                                                <span onClick={() => onHandleClick(selectedAction)} className=" font-museobb  inline-flex justify-center rounded-l-full rounded-r-full  bg-[#40BA47] py-2 px-8 text-sm  text-white cursor-pointer  focus:outline-none  my-1" >
                                                    Save
                                                </span>
                                            </div>



                                        </div>

                                    </div>
                                )}



                                <div className='flex mb-0  flex-col'>

                                    {item?.status === "Link posted" && (
                                        <div className="social-post-single-wrapper py-2 px-4 flex md:flex-row flex-col justify-evenly ">
                                            {item?.post_data?.map(post => (

                                                <div key={`post=${post?.id}`} className="social-post rounded-xl  max-w-[400px] p-2" style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >

                                                    <div className='image-container'>
                                                        <img alt='card-img' src={post?.photo} className="w-full max-h-[188px] outline-none   border-none  rounded-t-xl  " />
                                                    </div>

                                                    <div className='description-container  '>
                                                        <div className='title break-all py-2 font-museobb '>{post?.text}</div>
                                                        <div className={` pl-2 my-2 lg:my-0 break-all flex copy-text  sm:max-w-[auto] sm:min-w-[auto]`}>
                                                            <div className=' self-center font-museob lg:text-[15px] sm:text-[10px] p-2 '>
                                                                {post?.post_link?.length > 30 ? (
                                                                    `${post?.post_link.slice(0, 30)} ...`
                                                                ) : (
                                                                    post?.post_link
                                                                )}
                                                            </div>
                                                            <div className={`${getTrackLinkColor(post?.social_platform_id)} lg:w-[58px] w-[90px] cursor-pointer h-auto flex justify-center items-center rounded-r-lg `} >
                                                                <img onClick={(e) => { e.preventDefault(); e.stopPropagation(); copyToClipBoard(post?.post_link); }}
                                                                    alt='post-link' src={linkCopy} ></img>
                                                            </div>
                                                        </div>

                                                        <div className='date my-2 '>
                                                            <span className={`font-museob text-white  p-1 rounded ${getTrackLinkColor(post?.social_platform_id)}`}>
                                                                {post?.social_platform_id === 1 ? 'Facebook' : "Intagram"}
                                                            </span>
                                                        </div>
                                                        <div className='date '><span className='font-museobb'>Posted On : </span> {post?.created_time}</div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>

                                    )}
                                    {item?.status === 'Approved' && (
                                        <div key={`my-posts `} className='mx-10 px-3' >
                                            <div className="bg-white rounded-lg my-5 "
                                                style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >
                                                <h5 className="text-[#178ACB] text-lg font-museobb ml-5 pt-3">{item?.campaign?.campaign_title} </h5>
                                                <div className="mx-5 " >
                                                    {item?.post_data?.map(livePost => (
                                                        <div key={`live-post-data-${livePost?.post_id}`} className=' flex lg:flex-row flex-col w-full  lg:my-3 ' >
                                                            <div className={` pl-2 my-2 lg:my-0 break-all flex copy-text lg:max-w-[530px] lg:min-w-[530px] sm:max-w-[auto] sm:min-w-[auto]`}>
                                                                <div className=' self-center font-museob lg:text-[15px] sm:text-[10px] p-2 '>
                                                                    {livePost?.post_link?.length > 50 ? (
                                                                        `${livePost?.post_link?.slice(0, 50)} ...`
                                                                    ) : (
                                                                        livePost?.post_link
                                                                    )}
                                                                </div>
                                                                <div className={`${getTrackLinkColor(livePost?.social_platform_id)} lg:w-[58px] w-[90px] cursor-pointer h-auto flex justify-center items-center rounded-r-lg `} >
                                                                    <img onClick={(e) => { e.preventDefault(); e.stopPropagation(); copyToClipBoard(livePost?.post_link); }}
                                                                        alt='post-link' src={linkCopy} ></img>
                                                                </div>
                                                            </div>
                                                            <div className='flex my-2 lg:my-0 md:ml-8 sm:ml-0  sm:flex-row flex-wrap sm:gap-x-0 gap-x-2 font-museob text-center' >
                                                                {
                                                                    livePost?.social_platform_id === 1 && (
                                                                        <>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={like} alt='like' ></img>  <p className='pt-1'>{livePost?.total_likes}</p> </div>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={love} alt='love' ></img>  <p className='pt-1'>{livePost?.love}</p> </div>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={haha} alt='haha' ></img>  <p className='pt-1'>{livePost?.haha}</p> </div>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={wow} alt='wow'></img>     <p className='pt-1'>{livePost?.wow}</p> </div>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={sad} alt='sad'></img>     <p className='pt-1'>{livePost?.sad}</p> </div>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={angry} alt='angry'></img> <p className='pt-1'>{livePost?.angry}</p> </div>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={share} alt='share'></img> <p className='pt-1'>{livePost?.total_shares}</p></div>
                                                                        </>
                                                                    )
                                                                }
                                                                {
                                                                    livePost?.social_platform_id === 2 && (
                                                                        <>
                                                                            <div className="sm:mr-8 md:mr-10 "> <img src={like} alt='like' ></img>  <p className='pt-1'>{livePost?.total_likes}</p> </div>
                                                                            <div className="mr-10"><img src={love} alt='love' ></img> <p className='pt-1'>{livePost?.love}</p> </div>
                                                                            <div className="mr-10"><img src={send} alt='send' ></img> <p className='pt-1'>{livePost?.total_shares}</p> </div>
                                                                        </>
                                                                    )
                                                                }
                                                                {
                                                                    livePost?.social_platform_id === 3 && (
                                                                        <>
                                                                            <div className="mr-10"><img src={love_black} alt='love_black' ></img> <p className='pt-1'>{livePost?.love}</p> </div>
                                                                            <div className="mr-10"><img src={send_black} alt='send_black' ></img> <p className='pt-1'>{livePost?.total_shares}</p> </div>
                                                                        </>
                                                                    )
                                                                }

                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className=' py-2 lg:py-3 border-t font-museob flex  items-baseline justify-end' >
                                                        <p className='mr-3 ' >Total Cash Given</p>
                                                        <h3 className='font-museobb text-[#40BA47] ' >RM {currencyFormatter.format(item?.total_cash_eraned)}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {showStatusBasedOnCurrentStatusActions(item?.status).length > 0 && !showReasonForm && (
                                        <div className='flex md:flex-row flex-col  gap-y-3 md:gap-y-0 justify-around items-center py-5 h-full w-full flex-wrap '>
                                            {showStatusBasedOnCurrentStatusActions(item?.status)?.map(status => (
                                                <div key={`item-${status} `}>
                                                    <span onClick={() => { handleTaskAction(status) }} className={` i overflow-hidden transform hover:scale-x-110 hover:scale-y-105 transition duration-300 ease-out 
                                                    flex items-center justify-center col-span-2 text-white font-museobb ${getColorBasedStatus(status)}  text-center tracking-widest rounded-l-full rounded-r-full md:w-[220px] md:h-[55px] ssm:w-[150px] ssm:h-[35px] w-[120px] h-[30px]  cursor-pointer`} >

                                                        {getActionStatusName(status)}
                                                    </span>



                                                </div>
                                            ))}
                                        </div>
                                    )}

                                </div>

                            </div>
                        </motion.div>
                    </div>
                    <div className="opacity-60 fixed inset-0 z-40 bg-black duration-150 ease-in-out transition  active:shadow-lg "></div>
                </>
            ) : null
            }
        </>


    )

};



export default DetailModal;